




























import GlobalMixin from "@/mixins/global";
export default GlobalMixin.extend({
  props: ["headers", "items", "sortBy", "loading", "titleTable"],
  data() {
    return {
      // GENERAL
      moduleName: "DATATABLE_REPORT",
      // DATATABLES
      headerProps: {
        sortByText: "Ordenar por",
      },
      footerProps: {
        itemsPerPageText: "Registros por página",
        itemsPerPageAllText: "Todos",
        pageText: "{0}-{1} de {2}",
        sortByText: "Ordenar por",
      },
      loadingText: "Cargando... Por favor espere",
      noDataText: "Sin datos",
    };
  },
});
